import { render, staticRenderFns } from "./HeadBuyerSampleRequestModal.vue?vue&type=template&id=5ad94a8a&scoped=true&lang=pug"
import script from "./HeadBuyerSampleRequestModal.vue?vue&type=script&lang=js"
export * from "./HeadBuyerSampleRequestModal.vue?vue&type=script&lang=js"
import style0 from "./HeadBuyerSampleRequestModal.vue?vue&type=style&index=0&id=5ad94a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad94a8a",
  null
  
)

export default component.exports